const typeFunctionAvailables = [
  { label: 'Coordinador', keyword: 'COORDINADOR' },
  { label: 'Integrante', keyword: 'INTEGRANTE' },
  { label: 'Director', keyword: 'DIRECTOR' },
];

export default typeFunctionAvailables;
